export interface BaseServiceOutputMetadataError {
	code?: ErrorCode | string | null;
	message?: string | null;
}

export interface BaseServiceOutputMetadata<TInput> {
	success?: boolean | null;
	errors?: BaseServiceOutputMetadataError[] | null;
	input?: TInput | null;
}

export interface BaseServiceOutput<TInput, TOutput> {
	metadata?: BaseServiceOutputMetadata<TInput> | null;
	data?: TOutput | null;
}

export enum ErrorCode {
	SessionExpired = '1111',
	SessionExpired1 = '-1',
}
